import { resolveEmployeeFromUser } from "@components/utils/authEmployeeContext";

export function patchAccessPermission({ accessPermission, accountId, user, isEnabled }) {
  if (!accessPermission) {
    return accessPermission;
  }

  const patchedAccessPermission = {
    ...accessPermission,
  };

  const matchingUserEmployee = resolveEmployeeFromUser(user, accountId);

  // Legacy accounts can keep the employee on the user/login payload while the
  // access payload omits it when employee.access is not linked to the Access row.
  if (!patchedAccessPermission.employee && matchingUserEmployee) {
    patchedAccessPermission.employee = {
      id: matchingUserEmployee.id,
      first_name: matchingUserEmployee.first_name,
      last_name: matchingUserEmployee.last_name,
      email: matchingUserEmployee.email,
      current_status: matchingUserEmployee.current_status,
      avatar: matchingUserEmployee.avatar,
    };
  }

  if (!isEnabled) {
    return patchedAccessPermission;
  }

  if (
    patchedAccessPermission.has_access &&
    !patchedAccessPermission.is_suspended &&
    patchedAccessPermission.employee?.id &&
    patchedAccessPermission.employee?.current_status === "active"
  ) {
    patchedAccessPermission.has_employee = true;
    patchedAccessPermission.your_stuff_permission = true;
  }

  // Legacy administrator records can miss readiness access even though the UI
  // expects it to unlock role visibility.
  if (
    patchedAccessPermission.has_access &&
    !patchedAccessPermission.is_suspended &&
    patchedAccessPermission.admin_permission === "admin" &&
    !patchedAccessPermission.has_readiness_access
  ) {
    patchedAccessPermission.has_readiness_access = true;
  }

  return patchedAccessPermission;
}
